<template>
  <div v-if="option.available_for_ajout_option(commande_inscription)">
    <div
      class="container_option_item d-flex flex-wrap justify-start align-start gap bordered rounded bg-grey_1 pa-1 mb-2">
      <div class="container_visuel_option bordered rounded" v-if="has_visuel">
        <a :href="has_visuel.valeur" target="_blank">
          <img class="visuel_option" :src="has_visuel.valeur" :alt="'visuel ' + option.nom" />
        </a>
      </div>
      <div class="d-flex flex-column">
        <div class="text-h6 ml-1" style="margin-right: auto">Option: {{ option.nom }} - {{ option.get_text_prix() }}
        </div>
        <div class="text-body ml-1" v-if="option.information_supplementaire != ''"
          v-html="option.information_supplementaire"></div>
        <div class="text-body ml-1" v-if="option.information_variante_tarif != ''">{{ option.information_variante_tarif
          }}</div>
        <div class="text-body ml-1">Places réservables: {{ places_disponibles }}</div>
      </div>

      <div class="justify-self-end" v-if="option.is_complet()">
        <v-chip square color="dark-red">Complet</v-chip>
      </div>
      <div class="justify-self-end" v-else-if="option.is_closed()">
        <v-chip square color="dark-red">Inscriptions closes</v-chip>
      </div>
      <div class="justify-self-end" v-else-if="exceed_max()">
        <v-chip square color="dark-red">Maximum atteint</v-chip>
      </div>

      <div v-else class="d-flex flex-wrap align-center gap bg-white bordered pa-2 rounded justify-self-end">
        <div class="text-body-1 pt-2">Quantité</div>
        <v-btn @click="minus_quantity"><v-icon icon="mdi-minus"></v-icon> </v-btn>
        <div class="text-h6">{{ option.quantite_souhaite }}</div>
        <v-btn @click="plus_quantity"><v-icon icon="mdi-plus"></v-icon> </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["item", "commande_inscription", "all_commande_inscription"],
  data() {
    return {
      desired_quantity: 0,
      items: [],
      max_reservable: 0,
    };
  },
  watch: {
    all_commande_inscription: {
      handler: function () {
        this.build_quantity_items();
      },
      deep: true,
    },
  },
  computed: {
    places_disponibles() {
      const vip = null;
      const on_add_option_form = true;
      return this.option.get_places_disponibles(this.commande_inscription.list_options_amended, this.commande_inscription.list_options_amended, this.all_commande_inscription, vip, on_add_option_form, this.commande_inscription.list_commandes_options);
    },
    has_visuel() {
      let visuel = this.option.metadatas.filter((metadata) => metadata.nom == "visuel_option");
      if (visuel.length > 0) {
        return visuel[0];
      }
      return false;
    },
  },
  methods: {
    exceed_max() {
      let max_pour_option = this.option.get_max_quantite();
      for (let i = 0; i < this.commande_inscription.list_commandes_options.length; i++) {
        if (this.commande_inscription.list_commandes_options[i].type == "option" && this.commande_inscription.list_commandes_options[i].id_item == this.option.id) {
          max_pour_option -= parseInt(this.commande_inscription.list_commandes_options[i].quantite);
        }
      }
      return max_pour_option <= 0;
    },

    get_status() {
      if (parseInt(this.option.quantite) > 0 && parseInt(this.option.nb_inscrits) >= parseInt(this.option.quantite)) {
        return "complet";
      }
      if (moment(this.option.date_max).isValid()) {
        let now = moment();
        let date_max = moment(this.option.date_max + " " + this.option.heure_max);
        if (now.isAfter(date_max)) {
          return "closed";
        }
      }
      if (moment(this.option.date_min).isValid()) {
        let now = moment();
        let date_min = moment(this.option.date_min + " " + this.option.heure_min);
        if (now.isBefore(date_min)) {
          return "closed";
        }
      }

      return "disponible";
    },

    minus_quantity() {
      if (this.option.quantite_souhaite > 0) {
        this.option.quantite_souhaite--;
        this.$emit("updateQuantite", this.option.quantite_souhaite);
      }
    },
    plus_quantity() {
      if (this.places_disponibles > 0) {
        this.option.quantite_souhaite++;
        this.$emit("updateQuantite", this.option.quantite_souhaite);
      }
    },
    get_max() {
      let max = 30;
      for (let i = 0; i < this.option.metadatas.length; i++) {
        if (this.option.metadatas[i].nom == "quantite_max") {
          max = parseInt(this.option.metadatas[i].valeur);
          break;
        }
      }
      if (this.option.quantite != "0") {
        let restant = parseInt(this.option.quantite) - parseInt(this.option.nb_inscrits);
        if (restant < max) {
          max = Math.max(restant, 0);
        }
      }
      return max;
    },
    build_quantity_items() {
      for (let i = 0; i < this.places_disponibles; i++) {
        this.items.push(i);
      }
    },
    get_quantite_souhaite_local() {
      let quantite_souhaite = 0;
      if (!this.all_commande_inscription) {
        return 0;
      }
      for (let i = 0; i < this.all_commande_inscription.length; i++) {
        let commande_inscription = this.all_commande_inscription[i];
        if (!commande_inscription.list_options_amended) continue;
        for (let k = 0; k < commande_inscription.list_options_amended.length; k++) {
          let option = commande_inscription.list_options_amended[k];
          if (option.id == this.option.id) {
            quantite_souhaite += option.quantite_souhaite;
          }
        }
      }
      return quantite_souhaite;
    },
  },
  created() {
    this.option = this.item;
    this.build_quantity_items();
  },
};
</script>

<style lang="scss" scoped></style>